<template>
  <main class="security-page">
    <AppNavBar backgroundColor="#fff" :title="t('mine.security')" />

    <section class="security-card">
      <button type="button" class="security-item" @click="router.push('/mine/change-password')">
        <div class="security-item__left">
          <app-image src="@/assets/images/settingImage/modify_icon.png" alt="" />
          <span>{{ t('auth.changePassword') }}</span>
        </div>
        <app-image src="@/assets/images/rightArrow_icon.png" alt="" class="security-item__arrow" />
      </button>

      <button type="button" class="security-item security-item--last" @click="openRecoverPassword">
        <div class="security-item__left">
          <app-image src="@/assets/images/loginImage/lock_icon.png" alt="" />
          <span>{{ t('auth.resetPaymentPassword') }}</span>
        </div>
        <app-image src="@/assets/images/rightArrow_icon.png" alt="" class="security-item__arrow" />
      </button>
    </section>
  </main>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();

function openRecoverPassword() {
  router.push('/auth/forgot-pay-password');
}
</script>

<style scoped lang="scss">
.security-page {
  min-height: var(--app-viewport-height);
  padding: 0 0 24px;
  background: #ffffff;
}

.security-card {
  padding: 0 16px;
  border-radius: 16px;
  background: #ffffff;
  // box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);
}

.security-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 22px 0;
  border: 0;
  border-bottom: 1px solid #f0f1f3;
  background: transparent;
  text-align: left;
}

.security-item--last {
  border-bottom: 0;
}

.security-item__left {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;

  .app-image {
    width: 20px;
    height: 20px;
    flex: 0 0 auto;
    object-fit: contain;
  }

  span {
    color: #222222;
    font-size: 16px;
    line-height: 22px;
  }
}

.security-item__arrow {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  object-fit: contain;
}
</style>
